"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewNegotiationOfferReview = exports.impressionDisputeModalFeedback = exports.clickSendNegotiationOfferSuccess = exports.clickSendNegotiationOfferClose = exports.clickSendNegotiationOffer = exports.clickNegotiationOfferReviewRejectSuccess = exports.clickNegotiationOfferReviewReject = exports.clickNegotiationOfferReviewClose = exports.clickNegotiationOfferReviewAcceptSuccess = exports.clickNegotiationOfferReviewAccept = exports.clickDisputeModalFeedbackSend = exports.clickDisputeModalFeedbackClose = void 0;
// ====================================================================
// Functions actions
// ====================================================================

var viewNegotiationOfferReview = exports.viewNegotiationOfferReview = function viewNegotiationOfferReview() {
  return function (dispatch, _, _ref) {
    var Lurker = _ref.Lurker;
    Lurker.viewNegotiationOfferReview();
  };
};
var clickNegotiationOfferReviewClose = exports.clickNegotiationOfferReviewClose = function clickNegotiationOfferReviewClose() {
  return function (dispatch, _, _ref2) {
    var Lurker = _ref2.Lurker;
    Lurker.clickNegotiationOfferReviewClose();
  };
};
var clickNegotiationOfferReviewAccept = exports.clickNegotiationOfferReviewAccept = function clickNegotiationOfferReviewAccept() {
  return function (dispatch, _, _ref3) {
    var Lurker = _ref3.Lurker;
    Lurker.clickNegotiationOfferReviewAccept();
  };
};
var clickNegotiationOfferReviewAcceptSuccess = exports.clickNegotiationOfferReviewAcceptSuccess = function clickNegotiationOfferReviewAcceptSuccess() {
  return function (dispatch, _, _ref4) {
    var Lurker = _ref4.Lurker;
    Lurker.clickNegotiationOfferReviewAcceptSuccess();
  };
};
var clickNegotiationOfferReviewReject = exports.clickNegotiationOfferReviewReject = function clickNegotiationOfferReviewReject() {
  return function (dispatch, _, _ref5) {
    var Lurker = _ref5.Lurker;
    Lurker.clickNegotiationOfferReviewReject();
  };
};
var clickNegotiationOfferReviewRejectSuccess = exports.clickNegotiationOfferReviewRejectSuccess = function clickNegotiationOfferReviewRejectSuccess() {
  return function (dispatch, _, _ref6) {
    var Lurker = _ref6.Lurker;
    Lurker.clickNegotiationOfferReviewRejectSuccess();
  };
};
var clickSendNegotiationOffer = exports.clickSendNegotiationOffer = function clickSendNegotiationOffer() {
  return function (dispatch, _, _ref7) {
    var Lurker = _ref7.Lurker;
    Lurker.clickSendNegotiationOffer();
  };
};
var clickSendNegotiationOfferClose = exports.clickSendNegotiationOfferClose = function clickSendNegotiationOfferClose() {
  return function (dispatch, _, _ref8) {
    var Lurker = _ref8.Lurker;
    Lurker.clickSendNegotiationOfferClose();
  };
};
var clickSendNegotiationOfferSuccess = exports.clickSendNegotiationOfferSuccess = function clickSendNegotiationOfferSuccess() {
  return function (dispatch, _, _ref9) {
    var Lurker = _ref9.Lurker;
    Lurker.clickSendNegotiationOfferSuccess();
  };
};
var impressionDisputeModalFeedback = exports.impressionDisputeModalFeedback = function impressionDisputeModalFeedback(isSeller) {
  return function (dispatch, _, _ref10) {
    var Lurker = _ref10.Lurker;
    Lurker.impressionDisputeModalFeedback(isSeller);
  };
};
var clickDisputeModalFeedbackClose = exports.clickDisputeModalFeedbackClose = function clickDisputeModalFeedbackClose(isSeller) {
  return function (dispatch, _, _ref11) {
    var Lurker = _ref11.Lurker;
    Lurker.clickDisputeModalFeedbackClose(isSeller);
  };
};
var clickDisputeModalFeedbackSend = exports.clickDisputeModalFeedbackSend = function clickDisputeModalFeedbackSend(isSeller) {
  return function (dispatch, _, _ref12) {
    var Lurker = _ref12.Lurker;
    Lurker.clickDisputeModalFeedbackSend(isSeller);
  };
};